import React from 'react';
import PrimarySidebar from './PrimarySidebar';
import { useChatContext } from '../../context/ChatContext';
import { Lock } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getSubscriptionAccessState } from '../../utils/subscriptionAccess';

export default function DashboardContainer({ children }) {
  const { clientProfile } = useChatContext();
  const navigate = useNavigate();
  const location = useLocation();

  const isBilling = location.pathname.startsWith('/billing');

  const accessState = getSubscriptionAccessState(clientProfile);
  const remainingDays = accessState.remainingTrialDays;
  const isLocked = clientProfile ? !accessState.canAccessPaidFeatures : false;

  return (
    <div className="main-page-layout">
      <PrimarySidebar />
      <div className="dashboard-content" style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
        
        {/* Trial / Pending Banner */}
        {clientProfile && clientProfile.subscription_status !== 'active' && !isBilling && (
          <div style={{ background: 'var(--primary)', color: 'white', padding: '8px 16px', textAlign: 'center', fontSize: '0.88rem' }}>
            {accessState.pendingDuringTrial
              ? `Your free trial is still active for ${remainingDays} days. You can continue payment anytime from Billing.`
              : clientProfile.subscription_status === 'payment_required'
              ? 'Your account is created. Complete payment in Billing to unlock product features.'
              : clientProfile.subscription_status === 'pending'
              ? 'Payment is in progress. Complete checkout in Billing to unlock features.'
              : `Your free trial expires in ${remainingDays} days. Upgrade anytime from Billing.`}
          </div>
        )}

        {/* Lock Screen */}
        {isLocked && !isBilling ? (
          <div style={{
            position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.96)',
            zIndex: 50, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
          }}>
            <Lock size={48} color="var(--primary)" style={{ marginBottom: 16 }} />
            <h2 style={{ marginBottom: 8, fontSize: '1.5rem' }}>Trial Ended - Upgrade Required</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 24, textAlign: 'center', maxWidth: 400 }}>
              Your 14-day trial has ended. Please complete payment in Billing to continue using the product.
            </p>
            <button onClick={() => navigate('/billing')} style={{ padding: '10px 24px', fontSize: '1rem', background: 'var(--primary)', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 600 }}>
              Check Upgrade Options
            </button>
          </div>
        ) : null}

        <div style={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column', height: '100%' }}>
           {children}
        </div>
      </div>
    </div>
  );
}
